import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import { patchLeafletZoomTransitionCrash } from './utils/leafletPatches';

// Must run before any Leaflet map mounts — see utils/leafletPatches.ts
patchLeafletZoomTransitionCrash();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Failed to find the root element');
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
